export const CUSTOM_LOGIN_ERROR_MESSAGE = "error.user.loginFailed";

export const OVER_QUOTA_ERROR_MESSAGE = "error.shared.overQuota";

export const VEHICLE_ARCHIVED_ERROR_MESSAGE = "error.vehicle.vehicleArchived";
